var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMain2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 27C54 41.9117 41.9117 54 27 54C12.0883 54 0 41.9117 0 27C0 12.0883 12.0883 0 27 0C41.9117 0 54 12.0883 54 27Z",
    fill: "#111113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.0001H39.9999V40H14V14.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9687 26.0403V34.5157C37.9687 35.0757 37.5131 35.5313 36.9531 35.5313H17.0469C16.4869 35.5313 16.0312 35.0757 16.0312 34.5157V26.0403L14 24.5294V34.5157C14 36.1957 15.3668 37.5626 17.0469 37.5626H36.9531C38.6331 37.5626 39.9999 36.1957 39.9999 34.5157V24.5294L37.9687 26.0403Z",
    fill: "#F75524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain2);
export default __webpack_public_path__ + "static/media/main2.1824a6567f09dcad5cb5a1a70da640a6.svg";
export { ForwardRef as ReactComponent };